import { syncService } from '@app/modules/sync';
import { languageService } from '@app/modules/common/language';
import { alertService } from '@app/modules/common/alert';

/************************************************************************/
/* ASIGNACIÓN DE PULSERA RFID: ¿ya la tiene otro? / ¿reasignar?          */
/* Compartido por el editor de camarero y el de dueño (mismo flujo).     */
/************************************************************************/

export type RfidCheckScope = 'staff' | 'owner';

export interface RfidHolder {
    name: string;
    reassignable: boolean;      // ¿puede quien edita quitársela? (lo decide el server)
}

export class rfidAssignHelper {
    // Nombre de quien tiene YA esta pulsera (lo resuelve el server: el cliente no ve los
    // tags), o null si está libre o no se pudo comprobar (sin conexión / sin permiso): en
    // ese caso no se bloquea aquí y el server valida al guardar.
    //   scope 'staff': STAFF del local + su owner, excluyendo la ficha `exclude` (la editada)
    //   scope 'owner': el dueño edita SU ficha: STAFF de todos sus locales
    static async Holder(sync: syncService, lang: languageService, placeObjid: any, exclude: any, scope: RfidCheckScope, tag: string): Promise<RfidHolder> {
        try {
            let _data: any = await sync.DoRequest(
                'model/rfidcheck.php',
                { place: placeObjid },
                JSON.stringify({ rfid: tag, exclude: exclude || 0, scope: scope })
            );
            if (_data && (_data['errorcode'] == 0) && (_data['available'] === false)){
                let _h = _data['holder'] || {};
                return {
                    name: _h['name'] || lang.tr('@place_waiter_rfid_inuse_someone'),
                    reassignable: (_data['reassignable'] === true)
                };
            }
        }
        catch(e){
            // sin conexión: no bloquear aquí
        }
        return null;
    }

    // Tras capturar: ¿se queda con la pulsera? Libre → sí. En uso y con permiso → se
    // pregunta. En uso sin permiso → aviso y no (el server rechazaría el guardado).
    // Devuelve { assign, reassign }.
    static async Resolve(sync: syncService, lang: languageService, alertCtrl: alertService, placeObjid: any, exclude: any, scope: RfidCheckScope, tag: string): Promise<{ assign: boolean, reassign: boolean }> {
        let _holder = await rfidAssignHelper.Holder(sync, lang, placeObjid, exclude, scope, tag);
        if (!_holder){
            return { assign: true, reassign: false };
        }
        if (!_holder.reassignable){
            await rfidAssignHelper.Notice(alertCtrl, lang, _holder.name);
            return { assign: false, reassign: false };
        }
        let _ok = await rfidAssignHelper.Confirm(alertCtrl, lang, _holder.name);
        return { assign: _ok, reassign: _ok };
    }

    // "Esta pulsera ya la tiene X y no puedes reasignarla."
    static Notice(alertCtrl: alertService, lang: languageService, holder: string): Promise<void> {
        return new Promise((resolve) => {
            const alert = alertCtrl.alert({
                header: lang.tr('@place_waiter_rfid_inuse_title'),
                message: lang.tr('@place_waiter_rfid_inuse_noperm', [ holder ]),
                backdropDismiss: true,
                buttons: [{
                    text: lang.tr('@place_waiter_pin_ok'),
                    role: 'cancel'
                }]
            });
            alert.onDidDismiss().then(() => resolve());
            alert.present();
        });
    }

    // "Esta pulsera ya la tiene X. ¿Quitársela y asignarla aquí?" → true si reasignar.
    static Confirm(alertCtrl: alertService, lang: languageService, holder: string): Promise<boolean> {
        return new Promise((resolve) => {
            const alert = alertCtrl.alert({
                header: lang.tr('@place_waiter_rfid_inuse_title'),
                message: lang.tr('@place_waiter_rfid_inuse_message', [ holder ]),
                backdropDismiss: false,
                buttons: [{
                    text: lang.tr('@place_oneclick_cancel'),
                    handler: () => {
                        setTimeout(() => { alert.dismiss(false); }, 100);
                        return false;
                    }
                }, {
                    text: lang.tr('@place_waiter_rfid_reassign'),
                    handler: () => {
                        setTimeout(() => { alert.dismiss(true); }, 100);
                        return false;
                    }
                }]
            });
            alert.onDidDismiss().then((detail: any) => {
                resolve(!!(detail && (detail.data === true)));
            });
            alert.present();
        });
    }
}
